export const English = {
  poweredBy: "Powered by",
  cartEmpty: "Your cart is empty",
  are_you_sure_logout:"Are you sure you want to logout?",
  are_you_sure_delete_account:"Are you sure you want to delete your account?",
  account_delete_success:"Your request has been successfully accepted. We are reviewing your request to delete your account.",
  change: "Change",
  mycart: "My Cart",
  clearCart: "Clear Cart",
  delete_account:"Delete Account",
  profile_picture_action:"What would you like to do with your profile picture?",
  replace:"Replace",
  NotFound: {
    line1: "Page Not Found.",
    line2: "Oops! We couldn't find the page that you are looking for.",
  },
  
  "SomethingWrong": {
    "title": "Something went wrong",
    "message": "Please try again later.",
    "goBack": "Go back to Home"
  },
  Payment:{
    saved_card_future:"Save this card for future payments"
  },
  Login: {
    pleaseCheckTermAndConditions: "Please check terms of service and privacy policy",
    privatePolicy: "privacy policy.",
    and: "and",
    termOfService: " terms of service",
    byClickingAccept: "By clicking, I accept the",
    enterPhoneNumber: "Enter phone number",
    loginCreateAnAccountForFOE: "Login or create an account for a faster order experience",
    whatsYourPhoneNumber: "What's your phone number?",
    phoneNumber: "Phone number is required",
    forgot: "Forgot Password?",
    customerName: "Customer Name",
    mobile: "Mobile Number",
    signme: "Sign me in",
    submit: "Next",
    enterCustomer: "Enter Customer Name",
    enterMobile: "Enter Mobile Number",
    customerRequired: "Customer Name is required",
    customerChar: "Customer name must be at lease 4 characters",
    mobileRequired: "Please enter a valid phone number",
    welcome: "Welcome to YOP",
    register: "If you don’t have an account register",
  },
  VerifyOtp: {
    enterPhoneNumber:"Enter Phone Number",
    seconds:"seconds",
    second:"second",
    resendOtpIn: "Resend OTP in",
    resendOtp: "Resend OTP",
    changeNumber: "Change Number",
    verifyWithOtp: "Verify with OTP sent to",
    heading: "Enter OTP sent on your number",
    submit: "Verify OTP",
    error: "Please enter a valid OTP",
    dontReceive: "Didn’t receive any OTP ?",
    resentOtp: "Resend OTP",
    enterOtp: "Enter OTP",
    continue: "Continue",
    info: "An 6 digit code has been sent to",
    newNumber: "Enter new number",
    cancel: "Cancel",
    update: "Update",
  },
  Forgot: {
    newPassword: "New Password",
    confirmPassword: "Confirm New Password",
    enterNewPassword: "Enter New Password",
    enterConfirmPassword: "Enter Confirm New Password",
    submit: "Submit",
  },
  Home: {
    currentlyWeDoNotProvideAnyService:"Sorry currently, we do not provide any service.",
    theStoreIsCurrentlyClosed:"Sorry, we are not accepting orders at the moment.",
    theStoreIsCurrentlyNotAccepting:"Sorry, the store is currently not accepting orders through the website at the moment.",
    closed:"Closed",
    open:"Open",
    changeStore:"Change Store",
    free:"Free",
    variations:"Variations",
    thisDishCanBeCustomized:"This Dish Can be customized",
    goToMenu:"Go to Menu",
    PleaseUseYourCurrentLocationToCheckAllStores: "Please use your current location to check all stores",
    oopsStoreNotFound: "Oops! Store not found",
    checkYourConnection: "Check your connection",
    tryAgain: "Try Again",
    noInternetConnectionFound: "No Internet connection found",
    ooops: "Ooops!",
    no: "No",
    yes: "Yes",
    areYouSureYouWantToChangeStore: "Are you sure you want to change store? You will lose your current basket if you do.",
    weAreUsingCoockies: "We are using cookies to give you the best experience on our website.",
    pickup: "Pickup",
    loading: "Loading...",
    WeSorry: "We're sorry",
    close: 'Close',
    required: "Required",
    choose: "Choose",
    addOns: "Add-ons",
    addToOrder: "Add to Order",
    pleaseSelectVariations: "Please select Variations",
    readMore: "Read More",
    featuredItems: "Featured items",
    viewCart: "View Cart",
    delivery: "Delivery",
    collection: "Collection",
    pickCol: "Click & Collect / Delivery",
    orderOnline: "Order Online",
    away: "away",
  },
  Register: {
    weNeedYourNameEmail: "We need your name & email in order to complete your profile.",
    completeYourProfile: "Complete your profile",
    register: "Register",
    registerText: "If you don’t have an account register",
    firstName: "First name is required",
    lastName: "Last name is required",
    email: "Please enter a valid email address",
    enterFirstName: "Enter Your First Name",
    enterLastName: "Enter Last Name",
    enterEmail: "Enter Email (Optional)",
    skip: "Skip",
  },
  Settings: {
    settings: "Settings",
    profileDetails: "Profile Details",
    orders: "Orders",
    myAddress: "My Addresses",
    changePassword: "Change Password",
    oldPassword: "Old Password",
    newPassword: "New Password",
  },
  Profile: {
    name: "Name",
    profile: "Profile",
    upload: "Upload Picture",
    firstName: "First Name",
    lastName: "Last Name",
    phoneNumber: "Phone Number",
    email: "Email",
    cancel: "Cancel",
    save: "Save",
    edit: "Edit",
    mobileNumberRequired: "Mobile Number required",
    firstNameRequired: "First Name required",
    lastNameRequired: "Last Name required",
    invalidEmail: "Invalid email address",
    emailRequired: "Email required",
  },
  MyOrders: {
    grandTotal:"Grand Total",
    addToMeal:"Add to Meal",
    deliveryAddress:"Delivery Address",
    writeYourReviewHere: "Write your review here...",
    giveRating: "Give Rating",
    pickupTime: "Pickup Time",
    pickupdate: "Pickup Date",
    preOrder: "Pre-order",
    orderCategory: "Order category",
    discount: "Discount",
    taxes: "Taxes",
    remainingAmount: "Remaining Amount",
    itemTotal: "Item Total",
    notes: "Notes",
    amount: "Amount",
    qty: "Qty",
    deliveryInstructions: "Delivery Instructions",
    order_note:"Order Note",
    scheduledTime: "Scheduled Time",
    orderType: "Order Type",
    orderID: "Order ID",
    orderSchedule: "Order Schedule",
    orderPlace: "Order Place",
    paymentMode: "Payment Mode",
    callRestaurant: "Call Restaurant",
    noDataFound: "No Data Found",
    minimumOrderFee: "Minimum order fee",
    noOrders: "No Orders",
    reOrder: "Reorder",
    orderPlaceOn: "Order Placed on",
    order_success_msg:"Your order has been placed successfully "
  },
  MyAddress: {
    addressDeletedSuccessfully: "Address deleted successfully",
    pleaseSelectAnAddress: "Please select an address",
    pleaseEnterPostcode: "Please enter postcode",
    deliveryNotAvailable: "Delivery not available",
    invalidPostcode: "Invalid postcode",
    selectAddress:"Select Address",
    changeAddress:"Change Address",
    noGiftsAndDiscountsAvailable:"No Gifts and Discounts available here.Check Back here soon",
    homeOffice:"Home/Office",
    selectAddressType: "Select Address type",
    addNewAddress: "Add new address",
    canNotFindYourAddresss: "Can,t find your address",
    instructionForDeliveryPartner: "Instruction for delivery partner",
    pleaseSelectAddress: "Please select address",
    selectAnAddress: "Select an address",
    searchForAPostCode: "Search for a postcode",
    addressTypeIsRequired: "Address Type is required",
    findAddresss: "Find Address",
    writeTextHere: "Write text here...",
    deliveryIsNotAllowed: "Currently, delivery is not allowed at this address. Please choose another address.",
    savedAddresses: "Saved Addresses",
    addInstruction: "Add instruction",
    chooseSavedAddress: "Choose Saved address",
    chooseANewAddress: "Choose a new address",
    saveSelect: "Save & Select",
    select: "Select",
    update: "Update",
    save: "Save",
    findAddress: "Find address?",
    enterAddressManually: "Enter address manually",
    canNotFindYourAddress: "Can’t find your address?",
    addresses: "Addresses",
    areYouSureWantToDeleteThisAddress: "Are you sure want to delete this address?",
    closed: "Closed",
    openUntil: "Open Until",
    closedOpensAt: "Closed Opens at",
    myAddress: "My Addresses",
    noAddress: "No address added yet",
    newAddress: "New Address",
    edit: "Edit",
    delete: "Delete",
    
    addAddress: "Add Address",
    editAddress: "Edit Address",
    addressType: "Address Type",
    home: "Home",
    office: "Office",
    other: "Other",
    fullAddress: "Full Address",
    enterFullAddress: "Enter Your Full Address",
    houseNo: "House No.",
    enterHouseNo: "Enter Your House No.",
    streetName: "Street Name",
    enterStreetName: "Enter Your Street Name",
    country: "Country",
    enterCountry: "Enter Your Country",
    state: "State",
    district: "District",
    enterDistrict: "Enter Your District",
    city: "City",
    enterCity: "Enter Your City",
    zipCode: "Zipcode",
    enterZipCode: "Enter Your Zip Code",
    submit: "Submit",
    addressRequired: "Address Required",
    fullAddressRequired: "Please enter your full address",
    houseNoRequired: "Please enter your house number",
    streetNameRequired: "Please enter your street name",
    countryRequired: "Please enter your country",
    // zipcodeRequired:"Plese enter your zipcode",
    districtRequired: "Please enter your district",
    cityRequired: "Please enter your city",
    stateRequired: "Please enter your state",
    loading: "Loading...",
    actions: "Actions",
    cancel: "Cancel",

  },
OrderSuccess: {
    downloadReceipt: "Download Receipt",
    orderSuccessfull: "Order Successful",
    order: "Order",
    payment: "Payment",
    totalSalesTax: "Total sales tax",
    newOrder: "New Order",
    hey: "Hey",
    orderId: "Order id",
    orderConfirmed: "Order Confirmed",
    thankYou: "Thank you!",
    orderOnWay: "Your order is on the way",
    continueOrder: "Continue Order",
    viewOrder: "View Order"
  },
  CartDetails: {
    platformFee:"Platform Fee",
    totalItems: "Total item",
    pleaseSelectAtLeastOneItem: "Please select at least one item",
    back: "Back",
    subTotals: "Sub Total",
    orderTotal: "Order Total",
    item: "Item",
    addMoreItems: "Add More Items",
    cartSummary: "Cart summary",
    subTotal: "SubTotal",
    total: "TOTAL",
    round_total:"Round Off",
    items: "Items",
    price: "Price",
    checkOut: "Checkout",
    are_you_sure:"Are you sure you want to delete this card?",
  },
  SearchFilter: {
    enterAddress: "Please enter address",
  },
  Header: {
    search: "Search",
    notification: "Notification",
    profile: "Profile",
    myOrders: "My Orders",
    logout: "Logout",
    selectOneItem: "Please select atleast one item",
  },
  Checkout: {
    min:"min",
    asap:"ASAP",
    securityCode:"Security code",
    expirationDate:"Expiration date",
    cardNumber:"Card number",
    paymentMethods:"Payment methods",
    chooseAPaymentOption:"Choose a Payment Option",
    selectADip:"Select a dip",
    thisDishCanBeVariation:"This Dish Can be variation",
    goToCheckout:"Go to Checkout",
    scheduleDelivery: "Schedule delivery",
    schedule: "Schedule",
    pickupAddress: "Pickup Address",
    deliveryOptions: "Delivery options",
    minimumOrderFee: "Minimum order fee",
    addANote: "Add a note",
    payWithAnother: "Pay  with  another",
    payWith: "Pay with",
    payment_option:"Payment Option",
    discount_label:"Discount",
    allergiesMessage: `Have a food allergy? Please note that we can not accommodate allergen requests for collection or delivery orders. To ensure your safety, please visit call restaurants to place your order.`,
    allergies: "ALLERGIES",
    currentlyWeDoNotProvideAnyService: "Currently, we do not provide any service.",
    pickup: "Pickup",
    unavailable: "Unavailable",
    readMore: "Read more",
    delivery: "Delivery",
    collection: "Collection",
    deliveryDetails: "Delivery details",
    firstName: "First Name",
    lastName: "Last Name",
    enterFirstName: "Please Enter First Name",
    enterLastName: "Please Enter Last Name",
    paymentMethod: "Payment method",
    addPaymentMethod: "Add Payment Method",
    orderSummary: "Order Summary",
    items: "Items",
    price: "Price",
    continueToPayment: "Continue to payment",
    orderTotal: "Order total",
    subTotal: "Sub Total",
    serviceFee: "Service Fee",
    deliveryFee: "Delivery Fee",
    Card_Fees:"Card Fee",
    firstNameLength: "First Name must be at least 4 characters",
    lastNameLength: "First Name must be at least 4 characters",
    pleaseSelect: "Please select",
    firstNameRequired: "First Name is required",
    lastNameRequired: "Last Name is required",
    deliveryAddress: "Delivery address",
    confirmOrder: "Confirm & Pay",
    cancel: "Cancel",
    save: "Save"
  },

  NoStoreFound: {
    NotFound: {}
  },

  HamburgerMenu: {
    logout: "Logout"
  },
  ProfileSidebar: {
    logout: "Logout"
  },

  EditAddress: {
    cancel: "Cancel",
    save: "Save",
  },
  Review: {
    sendFeedback:"Send Feedback",
    youRated:"You Rated",
    noReviewsAvailable:"No reviews available.",
    sortBy:"Sort by",
    highlyRecommended:"Highly Recommended",
    reviews: "Reviews",
    reviewOfThe: "Review of the",
    review: "Review",
    ratings: "ratings"
  }
};
